import { issuerDomainMapConstants, nameSpace } from "../constants/issuerDomainMap.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const createIssuerDomainMapping = (state = initialState, action) => {
  switch (action.type) {
    case issuerDomainMapConstants[`POST_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        error: null,
        response: null,
        request: action.request
      };
    case issuerDomainMapConstants[`POST_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case issuerDomainMapConstants[`POST_${nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        response: null,
        success: false,
        error: action.error
      };
    case issuerDomainMapConstants[`POST_${nameSpace}_RESET`]:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
